import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { mapClientLogo } from '../../Utils/clientHelpers';
import { destroySlickCarousel, initSlickWhenReady } from '../../Utils/carouselHelpers';
import { getClients } from '../../Utils/api';
import { useLanguage } from '../../i18n/LanguageContext';

const PARTNER_SLICK_OPTIONS = {
  autoplay: true,
  autoplaySpeed: 2800,
  speed: 700,
  pauseOnHover: true,
  infinite: true,
  arrows: false,
  dots: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 4, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1 } },
  ],
};

const PartnerLogos = ({
  className = 'rs-partner partner-main-home pt-70 md-pt-50',
  withContainer = true,
}) => {
  const slideRef = useRef(null);
  const { locale, revision } = useLanguage();
  const [clients, setClients] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;

    getClients()
      .then((data) => {
        if (!active) return;
        setClients((data || []).map(mapClientLogo).filter((item) => item.logo));
      })
      .catch((err) => {
        if (!active) return;
        console.warn('Failed to load client logos:', err?.message || err);
        setClients([]);
      })
      .finally(() => {
        if (active) setReady(true);
      });

    return () => {
      active = false;
    };
  }, [locale, revision]);

  useLayoutEffect(() => {
    const el = slideRef.current;
    return () => destroySlickCarousel(el);
  }, []);

  useLayoutEffect(() => {
    if (!ready || clients.length < 2) return undefined;

    const el = slideRef.current;
    destroySlickCarousel(el);
    return initSlickWhenReady(el, PARTNER_SLICK_OPTIONS);
  }, [ready, clients]);

  if (!ready || !clients.length) return null;

  const logos = (
    <div className="partner-logos-panel">
      <div className="partner-logos-slider slider" ref={slideRef}>
        {clients.map((client) => (
          <div key={client.id} className="partner-logo-slide">
            <div className="partner-logo-card">
              <a
                href={client.url}
                target="_blank"
                rel="noopener noreferrer"
                title={client.name}
              >
                <img src={client.logo} alt={client.name} loading="lazy" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className={`${className} partner-logos-section`}>
      {withContainer ? <div className="container">{logos}</div> : logos}
    </div>
  );
};

export default PartnerLogos;
